var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.32812 0.703125V2.57813M11.9531 0.703125V2.57813M6.32812 15.7031V17.5781M11.9531 15.7031V17.5781M2.57813 6.32812H0.703125M2.57813 11.9531H0.703125M17.5781 6.32812H15.7031M17.5781 11.9531H15.7031M4.45312 15.7031H13.8281C14.8636 15.7031 15.7031 14.8636 15.7031 13.8281V4.45312C15.7031 3.41759 14.8636 2.57813 13.8281 2.57813H4.45312C3.41759 2.57813 2.57813 3.41759 2.57813 4.45312V13.8281C2.57813 14.8636 3.41759 15.7031 4.45312 15.7031ZM6.32812 6.32812H11.9531V11.9531H6.32812V6.32812Z",
    stroke: "#232323",
    strokeWidth: 1.40625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.3210270df3b10576a8f1903a284d3302.svg";
export { ForwardRef as ReactComponent };